import React from 'react';
import { CeDealershipV1, DealershipVehicleV1 } from '../../services/dealerships/types';
import VehicleCard from './VehicleCard';

const NoVehicles = () => (
  <div className="border border-black bg-white rounded-lg p-4 text-center text-gray-600">
    <p>No Vehicles found.</p>
  </div>
);

type Props = {
  dealership: CeDealershipV1 | undefined;
  vehicles: DealershipVehicleV1[] | undefined;
  onVinClickDelete?: (vehicle: DealershipVehicleV1, dealership: CeDealershipV1) => void;
};

const VinList: React.FC<Props> = ({ dealership, vehicles, onVinClickDelete }) => {
  const guaranteeDealershipVehicle: DealershipVehicleV1[] = vehicles ?? [];
  return (
    <div className="mb-10">
      <h3 className="font-medium text-xl mb-2">Vehicles</h3>
      <div className="flex flex-wrap gap-4">
        {guaranteeDealershipVehicle.length > 0 ? (
          guaranteeDealershipVehicle.map((vehicle, index) => (
            <VehicleCard
              key={index}
              vehicle={vehicle}
              onClickDelete={(vehicle: DealershipVehicleV1) => {
                onVinClickDelete && onVinClickDelete(vehicle, dealership ?? {});
              }}
            />
          ))
        ) : (
          <NoVehicles />
        )}
      </div>
    </div>
  );
};

export default VinList;
